<template>
  <v-row justify="center">
    <v-img
      :src="imgSemDados"
      :max-width="maxWith"
      :max-height="maxHeigth"
      style="opacity: 0.3;"
    >
    </v-img>
    <v-col cols="12" class="d-flex justify-center align-self-center my-0 py-0">
      <h4>{{msg}}</h4>
    </v-col>
  </v-row>
  
</template>

<script>

import img from "@/assets/not_found.png"

export default {
  name: "Sem-Dados",
  props: {
    maxWith: {
      type: Number,
      default: 80
    },
    maxHeigth: {
      type: Number,
      default: 80
    },
    msg: {
      type: String,
      default: 'Sem Dados'
    }
  },
  data() {
    return {
      imgSemDados: img
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Comum/SemDados.vue